<template>
  <div class="main-box">
    <div class="login-box">
       <span  class="login-box-title">
          江西省新余市工伤事故调查认定申报系统
        </span>
      <div class="login-box-log" @keyup.enter="submitForm('ruleForm')">
        <span class="title">账号登录</span>
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
            class="ms-content"
          >
            <el-form-item prop="username">
              <el-input
                class="wt"
                placeholder="请输入账号"
                v-model="ruleForm.username"
                prefix-icon="el-icon-user"
                ref="input_name"
                tabindex="1"
                clearable
                @clear="get_focus('input_name')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                class="wt"
                placeholder="请输入密码"
                show-password
                v-model="ruleForm.password"
                prefix-icon="el-icon-lock"
                tabindex="2"
                ref="input_pwd"
                @clear="get_focus('input_pwd')"
                clearable
              ></el-input>
            </el-form-item>
            <div class="login-btn" v-show="LOGINSHOW">
              <el-button class="wt login-btn" type="primary" @click="submitForm('ruleForm')"
                  >登 录</el-button
                >
            </div>
            <div class="loading-btn" v-show="LOADINGSHOW">
              <el-button class="wt login-btn" type="primary" disabled>正 在 登 录...</el-button>
            </div>
          </el-form>
      </div>
  </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import { userLogin } from "@api/login";
import {GetDataSystemConfigList} from "../api/ApiSystemConfig"
import { setUserInfo, setToken,setSystemConfig } from "@/util/authority";

export default {
  data: function () {
    return {
      ruleForm: {
        qddm: "000",
        username: "",
        password: "",
        yzmcode: "",
        resource: false,
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
      },
      LOGINSHOW: true,
      LOADINGSHOW: false,
    };
  },
  methods: {
    get_focus(type) {
      this.$nextTick(() => {
        this.$refs[type].focus();
      });
    },
    //加载系统配置
    async loadSystemConfig(){
      GetDataSystemConfigList({
        queryModel: {
        },
        pageindex: 1,
        PageSize: 1000,
      }).then(function(res){
        setSystemConfig(res.entities);
      })
    },
    submitForm(formName) {
      var _this = this
      if (!this.LOGINSHOW) return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.LOGINSHOW = false;
          this.LOADINGSHOW = true;
          var params = {
            userCode: this.ruleForm.username,
            password: this.ruleForm.password,
          };

          userLogin(params)
            .then(({ id, token, userCode, userName, companyId, userPermissions }) => {
              if(userCode.toUpperCase() != "ADMIN") {
                // 菜单权限
                sessionStorage.setItem("userPermissions", JSON.stringify(userPermissions));
                if(userPermissions.length == 0) {
                  ElMessage({
                    message: "当前用户没有菜单权限，请联系管理员进行设置",
                    duration: 1500,
                    type: 'error',
                  })
                  this.LOGINSHOW = true;
                  this.LOADINGSHOW = false;
                }
              }
              sessionStorage.setItem("UserID", this.ruleForm.username);
              let userInfo = {
                UserName: "",
                CodeID: "",
                CompanyId : 1
              };
              userInfo.UserName = userName;
              userInfo.CodeID = userCode;
              userInfo.CompanyId = companyId
              setUserInfo(userInfo); //设置用户信息
              setToken(token); //设置用户信息
              this.$router.push("/");
              this.LOGINSHOW = true;
              this.LOADINGSHOW = false;
              _this.loadSystemConfig();
            })
            .catch(({ code, message, details, validationErrors }) => {
              console.log(message);
              ElMessage({
                message: message,
                duration: 1500,
                type: 'error',
              })
              this.LOGINSHOW = true;
              this.LOADINGSHOW = false;
            });
        } else {
          return false;
        }
      });
    },
    IsAdmin() {
      let strUsers = ["000", "ADMIN"];
      return strUsers.includes(this.ruleForm.username.toUpperCase())
        ? "1"
        : "0";
    },
  },
  components: {},

  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
  .main-box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    //background-color: red;
     background-image: url('../assets/login.png');
     background-size: 100% 100%;
     background-repeat: no-repeat;

    .login-box{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      &-title{
        width: 727px;
        height: 36px;
        font-size: 40px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 36px;
        margin-bottom: 86px;
      }
       &-log{
          width: 475px;
          height: 380px;
          background: #FFFFFF;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          padding:37px  60px ;
          box-sizing: border-box;
          .title{
            display: inline-block;
            font-size: 28px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000 !important;
            line-height: 36px;
             margin-bottom: 44px;
          }
          .wt{
              width: 360px;
              height: 50px; 
          }
          .login-btn{
            background: #4BA6FB;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
          }

        ::v-deep  .el-input {
             height: 50px; 
             line-height: 50px;
          }
        ::v-deep    .el-input__icon {
              font-size: 18px;
              color: #0747a6;
            }
        ::v-deep     .el-form-item {
            margin-bottom: 28px;
          }
         ::v-deep .el-input--prefix .el-input__inner {
              height: 100%;
          }
      }
    }
  }
</style>>

